import {createAction, handleActions} from 'redux-actions';
import {Api} from '../../api/api';
import _ from 'lodash';
import {fetchSubmitForm, fetchSubmitFormFailed, fetchSubmitFormSuccess} from "../common/submitForm";
import {onGetPriorConsents} from "./priorConsents";
import { logout, onForbidden } from '../account/login';

//- Actions
export const fetchGetPriorConsentByIdFailed = createAction('FETCH_GET_PRIOR_CONSENT_BY_ID_FAILED');
export const fetchGetPriorConsentByIdSuccess = createAction('FETCH_GET_PRIOR_CONSENT_BY_ID_SUCCESS');
export const fetchGetPriorConsentById = createAction(
    'FETCH_GET_PRIOR_CONSENT_BY_ID',
    (id) => Api.getPriorConsentById(id),
    () => ({
        apiCall: true,
        onSuccess: fetchGetPriorConsentByIdSuccess,
        onFail: fetchGetPriorConsentByIdFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onUpdatePriorConsent = (id, data) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(fetchUpdatePriorConsent(id, data));
};

export const fetchUpdatePriorConsent = createAction(
    'FETCH_UPDATE_PRIOR_CONSENT',
    (id, data) => Api.updatePriorConsent(id, data),
    () => ({
        apiCall: true,
        onSuccess: fetchSubmitFormSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onRemovePriorConsent = (id) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(fetchRemovePriorConsent(id));
};

export const onRemovePriorConsentSuccess = () => (dispatch) => {
    dispatch(fetchSubmitFormSuccess());
    dispatch(onGetPriorConsents())
};

export const fetchRemovePriorConsent = createAction(
    'FETCH_REMOVE_PRIOR_CONSENT',
    (id) => Api.removePriorConsent(id),
    () => ({
        apiCall: true,
        onSuccess: onRemovePriorConsentSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

//- State
const initialState = {
    data: null,
    error: null,
    fetching: false
};

//- Reducers
export default handleActions({
    FETCH_GET_PRIOR_CONSENT_BY_ID: (state) => {
        return {...state, data: null, error: null, fetching: true};
    },
    FETCH_GET_PRIOR_CONSENT_BY_ID_FAILED: (state, action) => {
        return {...state, data: null, error: action.payload, fetching: false};
    },
    FETCH_GET_PRIOR_CONSENT_BY_ID_SUCCESS: (state, action) => {
        return {...state, data: action.payload, error: null, fetching: false};
    }
}, initialState);

//- Selectors
export const getPriorConsent = state => state.priorConsent;

export const loadingPriorConsent = state => getPriorConsent(state).fetching;

export const getPriorConsentData = state => getPriorConsent(state).data;

export const getFormattedPriorConsent = state => {
    let data = getPriorConsentData(state);

    if (_.isNil(data)) {
        return null;
    }

    return _.pick(data, ['targetType', 'targetId', 'metadata', 'enabledTill', 'grantedPeriodDays', 'responseComment', 'createdAt']);
};



// WEBPACK FOOTER //
// ./src/reducers/consent/priorConsent.js